import styled from 'styled-components'
import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'
import { setSession } from 'utils/set-session'
import { prefetchCertificate, useCertificate } from 'querys/certificates'
import Navigation from 'components/navigation'
import OpenGraph from 'common/open-graph'
import Wrapper from 'common/wrapper'
import CertificatePreview from 'student/certificates/certificate-preview'
import CertificateInfo from 'student/certificates/certificate-info'
import CertificateForm from 'student/certificates/certificate-form'
import CertificateDescription from 'student/certificates/certificate-description'
import useInputValue from 'hooks/use-input-value'
import useSession from 'querys/session'

const StudentCertificateStyled = styled.main`
  display: grid;
  margin-block-start: 88px;
  margin-block-end: 48px;
  column-gap: 24px;
  row-gap: 40px;
  @media(min-width: 1024px) {
    margin-block-start: 48px;
    margin-block-end: 0;
    grid-template-columns: repeat(2, 1fr);
  }
`

function StudentCertificate({ url }) {
  const { profile: { first_name, last_name } } = useSession()
  const firstName = useInputValue(first_name)
  const lastName = useInputValue(last_name)
  const { data, isLoading, isError } = useCertificate()

  if (isLoading || isError) return null

  const {
    is_owner, user: { full_name }, course: { title }, certificate_png, preview,
  } = data

  return (
    <>
      <OpenGraph
        title={`Certificado de ${full_name}`}
        description={`${full_name} ha completado con éxito el ${title}`}
        url={url}
        image={certificate_png || preview}
        keyword={`Leonidas Estaban, Certificado de ${title}, ${full_name}, ${title}, Certificado de ${full_name}`}
      />
      <Navigation noCountdown />
      <Wrapper maxWidth="1200">
        <StudentCertificateStyled>
          <CertificatePreview firstName={firstName.value} lastName={lastName.value} />
          {!is_owner ? (
            <div data-cy="user-certificate">
              <CertificateDescription />
            </div>
          ) : (
            <div>
              <CertificateInfo />
              <CertificateForm firstName={firstName} lastName={lastName} />
            </div>
          )}
        </StudentCertificateStyled>
      </Wrapper>
    </>
  )
}


export const getServerSideProps = async ({ req, query }) => {
  const { certificate_uuid: uuid } = query
  const queryClient = new QueryClient()
  const { token } = setSession(req, queryClient)
  await prefetchCertificate({ queryClient, uuid, token })
  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      url: `https://leonidasesteban.com/certificados/${uuid}`,
    },
  }
}

export default StudentCertificate
